import React from 'react'
import './App.css';

import { Element } from 'react-scroll';
import Loading from './pages/Loading';
import CssBaseline from '@mui/material/CssBaseline';

const Home = React.lazy(()=> import('./pages/Home'))
const About = React.lazy(()=> import('./pages/About'))
const Projects = React.lazy(()=> import('./pages/Projects'))
const Contact = React.lazy(()=> import('./pages/Contact'))
const Appbar = React.lazy(()=> import('./components/Appbar'))




function App() {



  return (
    <React.Suspense fallback={<Loading/>}>
      <div>


        <CssBaseline/>
          <Appbar/>

          <Element name="Home">
            <Home />
          </Element>

          <Element name="about">
            <About />
          </Element>

          <Element name="projects">
            <Projects />
          </Element>

          <Element name="contacts">
            <Contact />
          </Element>


  
      </div>
    </React.Suspense>
  );
  
}

export default App;
